import React, { useState, useEffect, useRef } from "react";
import { 
    Box, 
    Typography, 
    Tooltip, 
    IconButton, 
    TextField, 
    Drawer, 
    Stack, 
    Button,
    InputAdornment
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { CommonGridToolBarWithFilterText } from '../../../Components/Common Components/CommonComponents';
import { Colors } from "../../../Styles/Colors";
import { ImagePaths } from "../../../Utility/ImagePaths";
import ToastMsg from '../../../Components/ToastMsg/ToastMsg';
import RestAPIService from '../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../Utility/API/Serviceurls';
import CommonDatePicker from '../../../Components/Common Components/CommonDatePicker';
import { DateTime } from 'luxon';
import { formatDate, AmountFormat } from '../../../Components/CommonFunctions/CommonFunctions';
import { AmountsCard } from '../../../Components/CommonCards/CommonCards';
import { DataGrid } from "@mui/x-data-grid";

const HistoPatDemoReport = () => {
    const datelist = {
        fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
        toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
        dateIndex: 1,
    }

    const [page, setpage] = useState(0);
    const [pageSize, setpageSize] = useState(10);
    const [reportData, setReportData] = useState([]);
    const [isloader, setisloader] = useState(false);
    const [filterOpen, setFilterOpen] = useState(false);
    const [errorMsg, seterrorMsg] = useState(false);
    const [errorMsgText, seterrorMsgText] = useState('');
    const [successMsg, setsuccessMsg] = useState(false);
    const [successMsgText, setsuccessMsgText] = useState('');
    const [filterData, setfilterData] = useState({
        ...datelist,
        patient_name: ''
    });
    const [searchText, setSearchText] = useState('');
    const mountedRef = useRef(true);

    useEffect(() => {
        getReportData();
        return () => {
        mountedRef.current = false;
    };
    }, []);

    const errorMessage = (msg) => {
        seterrorMsgText(msg);
        seterrorMsg(true);
    }

    const successMessage = (msg) => {
        setsuccessMsgText(msg);
        setsuccessMsg(true);
    }

    const generateUrl = () => {
        let url = `${Serviceurls.HISTOPATHOLOGY_PATIENT_DEMOGRAPHICS_REPORT}?from_date=${filterData.fromDate}&to_date=${filterData.toDate}`;
        
        if (filterData.patient_name) {
            url += `&patient_name=${filterData.patient_name}`;
        }
        
        return url;
    }

    const getReportData = () => {
        try {
            setisloader(true);
            const url = generateUrl();
            RestAPIService.getAll(url)
                .then((response) => {
                    if (mountedRef.current) {
                    if (response.data.status === 'success') {
                        setReportData(response.data.data || []);
                        setisloader(false);
                    }}
                }).catch(e => {
                    if (mountedRef.current) {
                    setisloader(false);
                    if (e?.response?.data?.message) {
                        errorMessage(e.response.data.message);
                    } else {
                        errorMessage(e.message);
                    }
                }});
        } catch (e) {
            if (mountedRef.current) {
            setisloader(false);
            errorMessage(e.message);
        }}
    }

    const getReportPrint = () => {
        const url = generateUrl() + "&export_type=pdf";
        try {
            RestAPIService.getAllPrint(url)
                .then((response) => {
                    const file = new Blob(
                        [response.data],
                        { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                }).catch((error) => {
                    errorMessage(error?.response?.data?.message || error?.message);
                });
        } catch (error) {
            errorMessage(error.message);
        }
    }

    const FilterDate = (from, to, index) => {
        setfilterData({ ...filterData, fromDate: from, toDate: to, dateIndex: index });
    }

    const calculateTotalAmount = () => {
        return Array.isArray(reportData)
            ? reportData.reduce((total, item) => total + (item.total_bill_amount || 0), 0)
            : 0;
    }

    const calculateTotalTests = () => {
        return reportData.reduce((total, item) => total + (item.test_count || 1), 0);
    }

    const renderFilterScreen = () => {
        return (
            <Box className='eMed_rts_filter_container' >
                <Box className='eMed_filter_Top' sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                    <Typography variant='h6' fontWeight={600}>Filter</Typography>
                    <Tooltip title="Close">
                        <Button onClick={() => { setFilterOpen(false) }}>
                            <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_Canteen_CloseImg' />
                        </Button>
                    </Tooltip>
                </Box>
                <Box className='eMed_rts_middle' sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <Box className='eMed_date_filter'>
                        <CommonDatePicker
                            // FromDate={DateTime.fromFormat(filterData.fromDate, 'dd-MM-yyyy').toFormat('yyyy-MM-dd')}
                            FromDate={filterData.fromDate}
                            // ToDate={DateTime.fromFormat(filterData.toDate, 'dd-MM-yyyy').toFormat('yyyy-MM-dd')}
                            ToDate={filterData.toDate}
                            DateIndex={filterData.dateIndex}
                            SelectedDates={FilterDate.bind(this)}
                            HideAllMenu={true} />
                    </Box>
                    
                    {/* <TextField
                        size="small"
                        label="Patient Name"
                        value={filterData.patient_name}
                        onChange={(e) => setfilterData({ ...filterData, patient_name: e.target.value })}
                        fullWidth
                    /> */}
                </Box>
                <Box >
                    <Stack spacing={2} direction="row" justifyContent={'center'}>
                        <Button size='small' variant='outlined' className='eMed_Canteen_BtnText' 
                            onClick={() => { 
                                setfilterData({
                                    fromDate: DateTime.now().minus({days: 30}).toFormat('dd-MM-yyyy'),
                                    toDate: DateTime.now().toFormat('dd-MM-yyyy'),
                                    dateIndex: 1,
                                    patient_name: ''
                                });
                            }}>Clear</Button>
                        <Button size='small' variant='contained' className='eMed_Canteen_BtnText' 
                            onClick={() => {
                                getReportData();
                                setFilterOpen(false);
                            }}>Search</Button>
                    </Stack>
                </Box>
            </Box>
        );
    }

    const closeFilter = () => {
        setFilterOpen(false);
    }

    const handleSearch = (e) => {
        setSearchText(e.target.value);
    }

    const filteredData =( reportData || []).filter(item => 
        item.patient_name?.toLowerCase().includes(searchText.toLowerCase()) ||
        item.mobile_number?.includes(searchText) ||
        item.uhd_number?.toLowerCase().includes(searchText.toLowerCase()) ||
        item.email?.toLowerCase().includes(searchText.toLowerCase()) ||
        item.city?.toLowerCase().includes(searchText.toLowerCase())
    );

    const tableView = () => {
        const gridToolBar = () => {
            let TextArray = [
                { label: "From Date", value: formatDate(filterData.fromDate || "") },
                { label: "To Date", value: formatDate(filterData.toDate  || "")},
            ];
            
            if (filterData.patient_name) {
                TextArray.push({ label: "Patient Name", value: filterData.patient_name });
            }

            return (
                <Box>
                    <CommonGridToolBarWithFilterText FilterTextArray={TextArray} />
                </Box>
            );
        }

        const dataWithSno = filteredData?.map((item, index) => ({
            ...item,
            sno: (page * pageSize) + index + 1
        })) || [];

        const columns = [
            {
                field: 'sno',
                headerName: 'S No',
                flex: 0.05,
                minWidth: 60,
                renderCell: (params) => (
                    <Typography variant="body2" fontWeight="500">
                        {params.value.toString().padStart(2, '0')}
                    </Typography>
                )
            },
            {
                field: 'mobile_number',
                headerName: 'Mobile Number',
                flex: 0.1,
                minWidth: 130,
                renderCell: (params) => (
                    <Typography variant="body2">
                        {params?.row?.patient_mobile || '-'}
                    </Typography>
                )
            },
            {
                field: 'patient_name',
                headerName: 'Patient Name',
                flex: 0.15,
                minWidth: 160,
                renderCell: (params) => (
                    <Typography variant="body2" fontWeight="500">
                        {params?.row?.patient_name || '-'}
                    </Typography>
                )
            },
            {
                field: 'uhd_number',
                headerName: 'UHID',
                flex: 0.1,
                minWidth: 120,
                renderCell: (params) => (
                    <Typography variant="body2">
                        {params?.row?.patient_uhid || '-'}
                    </Typography>
                )
            },
            {
                field: 'email',
                headerName: 'Email',
                flex: 0.15,
                minWidth: 180,
                renderCell: (params) => (
                    <Typography variant="body2">
                        {params?.row?.patient_email || '-'}
                    </Typography>
                )
            },
            {
                field: 'city',
                headerName: 'City',
                flex: 0.1,
                minWidth: 120,
                renderCell: (params) => (
                    <Typography variant="body2">
                        {params?.row?.patient_city || '-'}
                    </Typography>
                )
            },
            {
                field: 'total_amount',
                headerName: 'Amount',
                flex: 0.1,
                minWidth: 120,
                renderCell: (params) => (
                    <Typography variant="body2" fontWeight="600">
                        {AmountFormat(params?.row?.total_bill_amount || 0)}
                    </Typography>
                )
            },
        ];

        return (
            <Box sx={{ height: '67vh', marginTop: '.5vw', backgroundColor: 'white' }}>
                <DataGrid
                    rows={dataWithSno}
                    columns={columns}
                    getRowId={(row) => row.sno}
                    page={page}
                    pageSize={pageSize}
                    rowCount={filteredData.length}
                    localeText={{
                        toolbarColumns: "",
                        toolbarDensity: "",
                        toolbarExport: "",
                        toolbarFilters: "",
                        toolbarExportPrint: ""
                    }}
                    components={{
                        Toolbar: gridToolBar,
                        NoRowsOverlay: () => (
                            <Box sx={{ 
                                display: 'flex', 
                                justifyContent: 'center', 
                                alignItems: 'center', 
                                height: '100%' 
                            }}>
                                {'No Records To Be Shown'}
                            </Box>
                        )
                    }}
                    onPageChange={(newPage) => { setpage(newPage) }}
                    onPageSizeChange={(newPageSize) => { setpageSize(newPageSize) }}
                    rowsPerPageOptions={[10, 20, 30]}
                    pagination
                    paginationMode="client"
                    headerHeight={40}
                    density='standard'
                    disableSelectionOnClick
                    loading={isloader}
                />
            </Box>
        );
    }

    const msgClose = () => {
        seterrorMsg(false);
        seterrorMsgText("");
        setsuccessMsg(false);
        setsuccessMsgText("");
    }

    return (
        <Box sx={{ 
            height: '79.5vh', 
            width: '94vw', 
            backgroundColor: Colors.Background, 
            padding: '.5vw' 
        }}>

            {/* Cards Section */}
            <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'} mb={2}>
                <Box display={'flex'} flexDirection={'row'} gap={2} marginLeft={'-.8vw'}>
                    {AmountsCard('Total Amount', AmountFormat(calculateTotalAmount()), true)}   
                    {AmountsCard('Total Test', calculateTotalTests().toString(), true)}
                </Box>
                <Box display="flex" alignItems="center" >
                    
                    {/* Filter and Print Buttons */}
                    <IconButton onClick={() => { setFilterOpen(true) }}>
                        <img 
                            style={{ width: '2vw', height: '2vw' }} 
                            src={ImagePaths.Filter.default} 
                            alt='filter' 
                        />
                    </IconButton>
                    <IconButton onClick={getReportPrint}>
                        <img 
                            style={{ width: '2vw', height: '2vw' }} 
                            src={ImagePaths.LabPrintIcon.default} 
                            alt='print' 
                        />
                    </IconButton>
                </Box>
            </Box>
            
            {/* Table Section */}
            <Box>
                {tableView()}
            </Box>
            
            {/* Filter Drawer */}
            <Drawer
                anchor={'right'}
                open={filterOpen}
                onClose={closeFilter}
                ModalProps={{ onBackdropClick: closeFilter }}
            >
                {renderFilterScreen()}
            </Drawer>
            
            {/* Toast Messages */}
            {errorMsg &&
                <ToastMsg
                    severity={'error'}
                    msg={errorMsgText}
                    msgPop={msgClose.bind(this)}
                />
            }
            {successMsg &&
                <ToastMsg
                    severity={'success'}
                    msg={successMsgText}
                    msgPop={msgClose.bind(this)}
                />
            }
        </Box>
    );
}

export default HistoPatDemoReport;